export const urlValidator = (url: string): boolean => {
  const validUrlRegex =
    /^(https?):\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+([/?#][a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]*)?$/;
  return validUrlRegex.test(url);
};
